/* ML product page bits - 31 Aug 2026 -----------------------------------------
   Item 10: "Special Order Items May Vary In Price" was showing on every product,
   including ones sitting directly above the words IN STOCK with a live Add to
   cart button. Two contradictory statements an inch apart.

   The notice is a THEME EDITOR text block (templates/product.json ->
   sections.main.blocks.text_wmBBbt), so it has no class of its own and no
   condition available to it. It is matched here by its exact text and then kept
   in step with the Add to cart button: the stock gate already flips that button
   to "SPECIAL ORDER - CONTACT US" and disables it, so the button is the single
   source of truth and the notice simply follows it.

   Eli can still edit or delete the block in the theme editor; change the wording
   there and NOTE below has to change with it.

   The observer watches ATTRIBUTES on the button only, and writes to a different
   element, so it cannot re-trigger itself - the trap that hung the renderer on
   30 Aug was a childList observer whose callback wrote text.
--------------------------------------------------------------------------- */
(function(){
  var NOTE = "special order items may vary in price";

  function findNote(){
    var all = document.querySelectorAll(".product-single__meta p, .product-single__meta div, .product-block, .product-block p, .product-block div");
    for(var i = 0; i < all.length; i++){
      var t = (all[i].textContent || "").trim().toLowerCase();
      if(t === NOTE) return all[i];
    }
    return null;
  }
  function findBtn(){
    return document.querySelector('form[action*="/cart/add"] button[name="add"]');
  }

  var note = null;

  function sync(){
    if(!note) note = findNote();
    var b = findBtn();
    if(!note || !b) return;
    /* special order === the gate has disabled the button */
    note.style.display = b.disabled ? "" : "none";
  }

  function start(){
    note = findNote();
    if(!note) return;
    sync();
    var b = findBtn();
    if(b && window.MutationObserver){
      new MutationObserver(sync).observe(b, { attributes: true, attributeFilter: ["disabled", "class"] });
    }
    /* Swatch King rebuilds the picker on every option change and the gate runs
       just after it; these catch the cases the observer cannot see. */
    document.addEventListener("change", function(){ window.setTimeout(sync, 120); }, true);
    document.addEventListener("click",  function(){ window.setTimeout(sync, 260); }, true);
    window.setTimeout(sync, 900);
    window.setTimeout(sync, 2500);
  }

  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", start); }
  else { start(); }
})();


/* NOT HERE, deliberately: an "if it is on screen and unloaded, make it eager"
   safety net was added at 1:05 PM and taken straight back out. At 1920px this
   slideshow keeps roughly a dozen slides inside the viewport rectangle even
   though only one is visible, so the net promoted all of them and the page went
   to 11,871 KB across 465 requests - WORSE than the 10,371 KB it was sent to fix.
   Native loading="lazy" is the right mechanism; it just cannot be observed from a
   backgrounded automation tab, which is what prompted the net in the first place. */


/* ---------------------------------------------------------------------------
   Recently viewed - 31 Aug 2026, at Eli's request: style number, collection, price.

   Complete The Look and You may also like were fixed in Liquid (ml_short_vendor),
   but Recently viewed cannot be: theme.js builds those cards in JAVASCRIPT from
   the product JSON, after the page has loaded. No Liquid runs, so nothing can be
   passed to product-grid-item. There is no ?view= product template to hook either
   - the theme has none.

   So the title is rewritten here once the cards appear. It uses the HANDLE, which
   on this catalogue IS the style number (e1023 -> E1023) - no extra network calls,
   and no guessing at a variant. It is deliberately the style number rather than a
   variant SKU: a recently-viewed card links to /products/<handle> with no
   ?variant=, so there is no one SKU it could honestly claim to be showing.

   The observer watches childList on the container and writes TEXT inside it, which
   is exactly the shape that hung the renderer on 30 Aug. It is safe here because
   every card is stamped with data-ml-short="1" BEFORE its text is touched, and the
   handler returns immediately on anything already stamped - an attribute write does
   not fire a childList observer.
--------------------------------------------------------------------------- */
(function(){
  function styleNumber(href){
    if(!href) return null;
    var m = String(href).split("?")[0].match(/\/products\/([^/]+)$/);
    return m ? m[1].toUpperCase() : null;
  }

  function shorten(root){
    var cards = root.querySelectorAll(".grid-product");
    for(var i = 0; i < cards.length; i++){
      var c = cards[i];
      if(c.getAttribute("data-ml-short") === "1") continue;
      var a = c.querySelector('a[href*="/products/"]');
      var t = c.querySelector(".grid-product__title");
      var sn = styleNumber(a && a.getAttribute("href"));
      c.setAttribute("data-ml-short", "1");   /* stamp FIRST, then write */
      if(t && sn){
        var full = t.textContent.trim();
        t.textContent = sn;
        if(!c.querySelector(".ml-sr-title")){
          var sr = document.createElement("span");
          sr.className = "visually-hidden ml-sr-title";
          sr.textContent = full;          /* keep the real name for search engines */
          t.parentNode.insertBefore(sr, t.nextSibling);
        }
      }
    }
  }

  function start(){
    var sec = document.querySelector('[data-section-type="recently-viewed"]');
    if(!sec) return;
    shorten(sec);
    if(window.MutationObserver){
      new MutationObserver(function(){ shorten(sec); }).observe(sec, { childList: true, subtree: true });
    }
    [800, 2000, 5000, 12000].forEach(function(ms){ window.setTimeout(function(){ shorten(sec); }, ms); });
  }

  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", start); }
  else { start(); }
})();
